module.exports = __webpack_public_path__ + "img/503.5d719961.webp";